import React from 'react';
import AppRoute from './AppRoute';
import { notAuthenticatedHOC } from '../HOC';
import Login from '../Pages/Login';

/** --------  ** * Add public routes here (which doesn't require auth) * **   ---------*/
const publicRoutesList = [
  {
    component: Login,
    asyncReducerNames: [],
    path: '/login',
    exact: true,
  },
];

/** --------  ** * Routes ends here * **   ---------*/

const PublicRoutes = () =>
  publicRoutesList.map((routeObject, index) => (
    <AppRoute
      {...routeObject}
      authNoAuthHOC={notAuthenticatedHOC}
      key={index}
    />
  )) || [];

export default PublicRoutes;
